import React from "react";
import BackButton from "../components/BackButton";

export default function OfferingsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-amber-100 p-6">
      <BackButton className="mb-6" />
      <div className="text-center p-8">
        <div className="text-4xl">📅 Upcoming Offerings Coming Soon!</div>
        <div className="mt-2 text-sm text-gray-600">Stay tuned for exciting events and workshops.</div>
      </div>
    </div>
  );
}
